export interface IUser {
    id?: any;
    login?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    activated?: boolean;
    langKey?: string;
    authorities?: any[];
    createdBy?: string;
    createdDate?: Date;
    lastModifiedBy?: string;
    lastModifiedDate?: Date;
    password?: string;

    emailVerified?: boolean;
    alternativeEmail?: string;
    alternativeEmailVerified?: boolean;
    office?: string;
    phone?: string;
    phoneVerified?: boolean;
    fiscalCode?: string;
    challengeQuestion?: string;
    challengeAnswer?: string;
    pin?: string;
    challengeAnswerSetted?: boolean;
    privacyPolicyAcceptedVersion?: string;
    otpEmail?: string;
    otpPhone?: string;
    otpAlternativeEmail?: string;
    channelToResendOTP?: string;

    delay?: boolean;
    userType?: 'STANDARD' | 'EXTRA_UE' | 'EIDAS';
    pinEnabled?: boolean;
    showUserTypeDisplay?: boolean;
    changePasswordEnabled?: boolean;
    forgotPasswordEnabled?: boolean;
    forgotUsernameEnabled?: boolean;
    editProfileEnabled?: boolean;
    securityQuestionEnabled?: boolean;
    showPwdlessWarning?: boolean;
}

export interface IFirstLogin {
    username?: string;
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    email: string;
    altEmail: string;
    phone: string;
    question: string;
    answer: string;
    mobilePin?: string;
    emailPin?: string;
}

export class FirstLogin implements IFirstLogin {
    constructor(
        public oldPassword: string,
        public newPassword: string,
        public confirmNewPassword: string,
        public email: string,
        public altEmail: string,
        public phone: string,
        public question: string,
        public answer: string,
        public mobilePin?: string,
        public emailPin?: string
    ) {
        this.oldPassword = oldPassword ? oldPassword : '';
        this.newPassword = newPassword ? newPassword : '';
        this.confirmNewPassword = confirmNewPassword ? confirmNewPassword : '';
        this.email = email ? email : '';
        this.altEmail = altEmail ? altEmail : '';
        this.question = question ? question : '';
        this.answer = answer ? answer : '';
        this.mobilePin = mobilePin ? mobilePin : '';
        this.emailPin = emailPin ? emailPin : '';
    }

}

export class UpdateUser implements IUser {
    constructor(
        public email: string,
        public alternativeEmail: string,
        public office: string,
        public phone: string,
        public challengeQuestion: string,
        public challengeAnswer: string,
        public challengeAnswerSetted: boolean,
        public pin: string,
        public privacyPolicyAcceptedVersion: string,
        public emailVerified: boolean,
        public alternativeEmailVerified: boolean,
        public phoneVerified: boolean,
        public otpEmail?: string,
        public otpPhone?: string,
        public otpAlternativeEmail?: string,
        public channelToResendOTP?: string
    ) {
        this.email = email;
        this.alternativeEmail = alternativeEmail;
        this.office = office;
        this.phone = phone;
        this.challengeQuestion = challengeQuestion;
        this.challengeAnswer = challengeAnswer;
        this.challengeAnswerSetted = challengeAnswerSetted;
        //<!-- AGGIUNGERE CONDIZIONE DAG-RGS  -->
        this.pin = pin;
        this.privacyPolicyAcceptedVersion = privacyPolicyAcceptedVersion;
        this.emailVerified = emailVerified;
        this.alternativeEmailVerified = alternativeEmailVerified;
        this.phoneVerified = phoneVerified;
        this.otpEmail = otpEmail;
        this.otpPhone = otpPhone;
        this.otpAlternativeEmail = otpAlternativeEmail;
        this.channelToResendOTP = channelToResendOTP;
    }
}

export class User implements IUser {
    constructor(
        public id?: any,
        public login?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public activated?: boolean,
        public langKey?: string,
        public authorities?: any[],
        public createdBy?: string,
        public createdDate?: Date,
        public lastModifiedBy?: string,
        public lastModifiedDate?: Date,
        public password?: string,
        public emailVerified?: boolean,
        public alternativeEmail?: string,
        public office?: string,
        public phone?: string,
        public phoneVerified?: boolean,
        public fiscalCode?: string,
        public challengeQuestion?: string,
        public challengeAnswer?: string,
        //<!-- AGGIUNGERE CONDIZIONE DAG-RGS  -->
        public pin?: string,
        public privacyPolicyAcceptedVersion?: string
    ) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
        this.emailVerified = emailVerified ? emailVerified : false;
        this.alternativeEmail = alternativeEmail ? alternativeEmail : null;
        this.office = office ? office : null;
        this.phone = phone ? phone : null;
        this.phoneVerified = phoneVerified ? phoneVerified : false;
        this.fiscalCode = fiscalCode ? fiscalCode : null;
        this.challengeQuestion = challengeQuestion ? challengeQuestion : null;
        this.challengeAnswer = challengeAnswer ? challengeAnswer : null;
        //<!-- AGGIUNGERE CONDIZIONE DAG-RGS  -->
        this.pin = pin ? pin : null;
        this.privacyPolicyAcceptedVersion = privacyPolicyAcceptedVersion;
    }
}
